import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import VueGtag from 'vue-gtag'
import VueGtm from '@gtm-support/vue2-gtm'
import Home from '@/views/Home.vue'
import Play from '@/views/Play.vue'
import HowTo from '@/views/HowTo.vue'
import Steps from '@/views/howto/Steps.vue'
import Guide from '@/views/howto/Guide.vue'
import Hint from '@/views/howto/Hint.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'ミュージックメーカー｜おだきゅうキッズ｜小田急電鉄', desc: '' },
  },
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
  {
    path: '/play',
    name: 'Play',
    component: Play,
    meta: { title: 'ミュージックメーカー｜おだきゅうキッズ｜小田急電鉄', desc: '' },
  },
  {
    path: '/howto',
    name: 'HowTo',
    component: HowTo,
    meta: { title: '遊び方｜おだきゅうキッズ｜小田急電鉄', desc: '' },
  },
  {
    path: '/howto/steps',
    name: 'Steps',
    component: Steps,
    meta: { title: '進め方｜おだきゅうキッズ｜小田急電鉄', desc: '' },
  },
  {
    path: '/howto/guide',
    name: 'Guide',
    component: Guide,
    meta: { title: '操作ガイド｜おだきゅうキッズ｜小田急電鉄', desc: '' },
  },
  {
    path: '/howto/hint',
    name: 'Hint',
    component: Hint,
    meta: { title: 'アレンジのヒント｜おだきゅうキッズ｜小田急電鉄', desc: '' },
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

// https://www.npmjs.com/package/@gtm-support/vue2-gtm
Vue.use(VueGtm, {
  id: 'GTM-PLZQMKB',
  // debug: true,
  vueRouter: router,
})

// Gtagは不要になったのでコメントアウト
// Vue.use(VueGtag, {
//   config: { id: 'UA-9274103-1' },
//   pageTrackerTemplate (to: any) {
//     return {
//       // アナリティクス用にディレクトリのパスを指定する
//       // eslint-disable-next-line @typescript-eslint/camelcase
//       page_path: `/kids/music${to.path}`,
//     }
//   },
// }, router)

export default router
